﻿import {HttpClientError} from "@2d-front-monorepo/core";
import {IPermitsHttpClient, PermitsFrontClient} from "@2d-front-monorepo/permits-business";
import {GlobalContext} from "./GlobalContext";
import {userStore} from "./UserContext";
import { API_ENDPOINT } from "../api-endpoint";

function errorHandler(error: Error): void {
	if (error instanceof HttpClientError && error.status === 401) {
		userStore.patchState(x => x.authStatus = "unauthorized");
	}
}

export class HttpContext {
	private static _instance: HttpContext;
	private _client: IPermitsHttpClient;

	private constructor() {
		this._client = this.createClient();
	}

	static getClient(): IPermitsHttpClient {
		return HttpContext.getInstance()._client;
	}

	static reset(): void {
		HttpContext.getInstance().resetPrivate()
	}

	private static getInstance(): HttpContext {
		if (!this._instance) {
			this._instance = new HttpContext();
		}
		
		return this._instance;
	}

	private resetPrivate(): void {
		this._client = this.createClient();
	}

	private createClient(): IPermitsHttpClient {
		const installationId = GlobalContext.tryGetData()?.installation?.id;
		return  new PermitsFrontClient(API_ENDPOINT.root, installationId, errorHandler);
	}
}
